export const DEFAULT_TRANSITION_IN = "defaultTrIn";
export const DEFAULT_TRANSITION_OUT = "defaultTrOut";
export const DEFAULT_HOVER = "defaultHover";

export const TRANSITION_IN = "trIn";
export const TRANSITION_OUT = "trOut";

export const STATE_TRANSITION_IN = "stateTrIn";
export const STATE_TRANSITION_OUT = "stateTrOut";

export const AUTO_ADVANCE_VIEW_TIME = "aav";

export default {
  DEFAULT_TRANSITION_IN,
  DEFAULT_TRANSITION_OUT,
  DEFAULT_HOVER,
  TRANSITION_IN,
  TRANSITION_OUT,
  STATE_TRANSITION_IN,
  STATE_TRANSITION_OUT,
};
